import React, { FC } from 'react';
import ContentLoader from '@adsk/alloy-react-content-loader';

const ProjectsHeaderTitleLoader: FC = () => (
  <ContentLoader
    data-testid="ProjectsHeaderTitleLoader"
    height={30}
    width={160}
  >
    <rect height="30" rx="6" ry="6" width="160" x="0" y="0" />
  </ContentLoader>
);

export default ProjectsHeaderTitleLoader;
